module.exports = __webpack_public_path__ + "static/media/monthly student attendance.b4145592.svg";